var _rect, _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFillRegisterCert = function SvgFillRegisterCert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 40,
    x: 8,
    y: 4,
    fill: "#E3E6E9",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#C8CED4",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M15 12h18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6CA9FF",
    d: "m27.8 33.767 5.373-2.857 5.506 8.35-4.452.112L31.645 43z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A3C9FF",
    d: "m25.505 30.81 5.373 2.857-3.844 9.233-2.582-3.628L20 39.161z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.46,
    cy: 28.974,
    r: 5.975,
    fill: "#FFE357"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.46,
    cy: 28.974,
    r: 4.481,
    fill: "#F8C200"
  })));
};
export default SvgFillRegisterCert;